module.exports = require("./bas.d.ts");